// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getMessaging, getToken as firebaseGetToken, onMessage} from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyB_Oen2Qp8TUI1ShE7Ej0Y0mfvdxgFvO6k",
    authDomain: "blift-bd64f.firebaseapp.com",
    projectId: "blift-bd64f",
    storageBucket: "blift-bd64f.firebasestorage.app",
    messagingSenderId: "409907467747",
    appId: "1:409907467747:web:4324ff3912284dac7f3cd6",
    measurementId: "G-93KBB5JKBM"
};

// Initialize Firebase — single instance for the entire app
export const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export const getToken = (setTokenFound) => {
    return firebaseGetToken(messaging, {vapidKey: 'GENERATED_MESSAGING_KEY'}).then((currentToken) => {
        if (currentToken) {
            setTokenFound(true);
        } else {
            setTokenFound(false);
        }
    }).catch((err) => {
        console.error('An error occurred while retrieving token.');
    });
}